import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CampaignList } from '@/components/campaigns/CampaignList';
import { CampaignWizard } from '@/components/campaigns/CampaignWizard';

export function CampaignsPage() {
  const [showWizard, setShowWizard] = useState(false);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Campanhas</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Crie e gerencie campanhas de disparo
          </p>
        </div>
        <Button onClick={() => setShowWizard(true)}>
          <Plus className="h-4 w-4" />
          Nova campanha
        </Button>
      </div>

      <CampaignList />

      <CampaignWizard open={showWizard} onOpenChange={setShowWizard} />
    </div>
  );
}
